// Shared "copy diagnostics" bundle-builder for any error surface that wants
// to offer more than a bare message — the correlation id alone (see
// core/api.js's apiErrorFrom, backend logutil.py's X-Correlation-Id) is
// useless without enough context to actually go look it up, so this always
// bundles it with the time and page it happened on.
export function diagnosticsBundle({ message, correlationId }) {
  return [
    `Message: ${message}`,
    `Correlation ID: ${correlationId || 'n/a'}`,
    `Time: ${new Date().toISOString()}`,
    `URL: ${window.location.href}`,
  ].join('\n');
}

export function copyDiagnostics({ message, correlationId }) {
  return navigator.clipboard?.writeText(diagnosticsBundle({ message, correlationId }))
    ?? Promise.reject(new Error('Clipboard API unavailable'));
}
